<template>
  <SpeakolNotificationToaster
    :show="toaster.show"
    :message="toaster.message"
    :icon="toaster.icon"
    :closeButtonText="toaster.closeButtonText"
    @close="stopEveryXSecondsCheck"
  />
</template>

<script>
import SpeakolNotificationToaster from '@/components/SpeakolNotificationToaster'

export default {
  data () {
    return {
      toaster: {
        show: false,
        message: '',
        icon: null,
        closeButtonText: 'Cancel'
      },
      running_export_id: null,
      intervalChecker: null,
      checksNumber: 0,
      is_succeeded: false,
      maxChecksNumber: 30,
      xCheckSeconds: 5 * 1000
    }
  },
  watch: {
    running_export_id () {
      this.checkIfExportIsDoneEveryXSeconds()
    }
  },
  components: {
    SpeakolNotificationToaster
  },
  mounted () {
    this.$root.$on('speakol-export:started', (running_export_id) => {
      this.toaster = {
        show: true,
        message: 'Preparing report ...',
        icon: require('@/assets/images/inProgress.svg'),
        closeButtonText: 'Cancel'
      }

      this.running_export_id = running_export_id
    })
  },
  methods: {
    checkIfExportIsDoneEveryXSeconds () {
      this.intervalChecker = setInterval(async () => {
        if (!this.running_export_id || this.checksNumber >= this.maxChecksNumber) {
          this.stopEveryXSecondsCheck(false)

          if (this.is_succeeded) {
            return
          }

          this.toaster = {
            show: true,
            message: 'Report export failed, Please try again later.',
            icon: require('@/assets/images/error.svg'),
            closeButtonText: 'Close'
          }
          return
        }

        const response = await window.axios.post(`/export/check/${this.running_export_id}`)

        // Increase number of checks each time the chacks the export state
        // will use this to stop the checking if the checksNumber is greater than {this.maxChecksNumber} checks
        this.checksNumber++

        const payload = response.data.payload

        if (payload.is_export_done) {
          this.running_export_id = null
          this.is_succeeded = true

          this.stopEveryXSecondsCheck()

          await this.downloadExportedFile(payload.download_url, payload.download_as)
        }
      }, this.xCheckSeconds)
    },
    stopEveryXSecondsCheck (resetToaster = true) {
      if (this.intervalChecker) {
        clearInterval(this.intervalChecker)
      }

      if (resetToaster) {
        this.resetToaster()
      }
    },
    downloadExportedFile (url, filename) {
      fetch(url).then((t) => {
        this.toaster = {
          show: true,
          message: 'Report downloaded',
          icon: require('@/assets/images/success.svg'),
          closeButtonText: 'Close'
        }

        t.blob().then((b) => {
          const a = document.createElement('a')
          a.href = URL.createObjectURL(b)
          a.setAttribute('download', filename)
          a.click()

          setTimeout(() => {
            this.resetToaster()
          }, 5000)
        })
      })
    },
    resetToaster () {
      this.toaster = {
        show: false,
        message: '',
        icon: null,
        closeButtonText: 'Cancel'
      }
    }
  }
}
</script>
